"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUserManagementClient = void 0;
const utils_1 = require("@webdev/utils");
const userAccount_1 = require("./apis/userAccount");
const managedAccountMapper_1 = require("./managedAccountMapper");
const makeUserManagementClient = (basePath) => {
    const authenticationApi = new userAccount_1.AuthenticationApi(new userAccount_1.Configuration({ basePath, credentials: 'include' }));
    const tokenCache = (0, utils_1.makeTokenCache)(() => __awaiter(void 0, void 0, void 0, function* () {
        const { accessToken, expiresIn } = yield authenticationApi.exchange({});
        return {
            access_token: accessToken,
            expires_in: expiresIn,
            token_format: 'jwt',
            scope: '',
        };
    }));
    const accessToken = () => __awaiter(void 0, void 0, void 0, function* () { return (yield tokenCache()).access_token; });
    const userApi = new userAccount_1.UserManagementApi(new userAccount_1.Configuration({
        basePath,
        accessToken,
    }));
    const licenceApi = new userAccount_1.LicenseManagementApi(new userAccount_1.Configuration({
        basePath,
        accessToken,
    }));
    return {
        getUser() {
            return __awaiter(this, void 0, void 0, function* () {
                return userApi.getMyAccount();
            });
        },
        getManagedAccounts() {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield userApi.getMyManagedAccounts()).map(managedAccountMapper_1.managedAccountMapper);
            });
        },
        inviteManagedUsers(emails) {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield userApi.inviteManagedUsers({ requestBody: emails })).map(managedAccountMapper_1.managedAccountMapper);
            });
        },
        removeManagedUsers(ids) {
            return __awaiter(this, void 0, void 0, function* () {
                yield userApi.removeManagedAccounts({ requestBody: ids });
            });
        },
        getMyLicenses() {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield licenceApi.getMyLicenses()).map(({ type, key, id, quantity, productName }) => ({
                    id: id,
                    key,
                    seats: quantity !== null && quantity !== void 0 ? quantity : 0,
                    productName: productName !== null && productName !== void 0 ? productName : '',
                    type,
                }));
            });
        },
        setManagedLicensesByUsers(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                yield licenceApi.setManagedLicensesByUsers({ requestBody: payload });
            });
        },
        getAllManagedLicensesByUsers() {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield licenceApi.getAllManagedLicensesByUsers());
            });
        },
        getAllManagedUsersByLicenses() {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield licenceApi.getAllManagedUsersByLicenses());
            });
        },
        setManagedUsersByLicenses(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                yield licenceApi.setManagedUsersByLicenses({ requestBody: payload });
            });
        },
    };
};
exports.makeUserManagementClient = makeUserManagementClient;
//# sourceMappingURL=client.js.map